<!--
 * @Author: your name
 * @Date: 2021-09-20 10:09:13
 * @LastEditTime: 2021-09-23 21:16:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\views\PC\createTask\createTask.vue
-->
<template>
  <div class="create-task">
    <div class="my-title">{{$t('Task.CreateABountyTask')}}</div>
      <el-form ref="form" :label-position="'top'" class="form_wrap">
        <div class="form-box">
          <el-form-item :label="$t('Task.TaskSubject')">
            <el-input v-model="formData.TaskSubject"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Task.TotalReward')">
            <el-input v-model="formData.TotalReward" class="input-with-select">
              <el-select v-model="select1" slot="append" :placeholder="$t('Task.selectPlaceholder')">
                <el-option label="USDT" value="1"></el-option>
                <el-option label="USDT" value="2"></el-option>
                <el-option label="USDT" value="3"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </div>
        <div class="form-box">
          <el-form-item :label="$t('Task.TaskType')">
            <el-select class="w-240" v-model="formData.TaskType">
              <el-option label="乘客" :value="0"></el-option>
              <el-option label="车主" :value="1"></el-option>
              <el-option label="司机" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Task.TheNumberOfParticipants')">
            <el-input v-model="formData.TheNumberOfParticipants"></el-input>
          </el-form-item>
        </div>
        <div class="form-box">
          <el-form-item :label="$t('Task.TaskDescribe')">
            <el-input v-model="formData.TaskDescribe"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Task.AcceptanceCriteria')">
            <el-input v-model="formData.AcceptanceCriteria"></el-input>
          </el-form-item>
        </div>
        <div class="form-box">
          <el-form-item :label="$t('Task.ActivityDate')">
            <el-date-picker
              v-model="formData.ActivityDate"
              type="datetimerange"
              range-separator="至"
              :start-placeholder="$t('Task.startTime')"
              :end-placeholder="$t('Task.endTime')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Task.EstimatedRewardTime')">
            <el-input v-model="formData.EstimatedRewardTime"></el-input>
          </el-form-item>
        </div>
        <div class="form-box">
          <el-form-item :label="$t('Task.ContactInformation')">
            <el-input v-model="formData.ContactInformation"></el-input>
          </el-form-item>
          <el-form-item>
            <!-- <el-input v-model="formData.EstimatedRewardTime"></el-input> -->
          </el-form-item>
        </div>
        <div class="saveBtn cancelselect">{{$t('Task.ConfirmRelease')}}</div>
      </el-form>
  </div>
</template>

<script>
export default {
  name: 'createTask',
  data () {
    return {
      formData: {
        CreateABountyTask: 'Create a Bounty Task',
        TaskSubject: 'Task Subject',
        TotalReward: 'Total Reward',
        TaskType: 'Task Type',
        TheNumberOfParticipants: 'The number of participants',
        TaskDescribe: 'Task Describe',
        AcceptanceCriteria: 'Acceptance Criteria',
        ActivityDate: 'Activity Date',
        EstimatedRewardTime: 'Estimated reward time',
        ContactInformation: 'Contact information',
        ConfirmRelease: 'Confirm Release'
      },
      select1: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.my-title{
  margin-top: 90px !important;
}
.el-date-editor{
  width: 100%;
}
</style>
